import React, { useEffect, useState } from "react";
import { vehicleService } from "../services/api";
import VehicleCard from "../components/VehicleCard";
import "./HomePage.css";

const HomePage = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        setLoading(true);
        const data = await vehicleService.getAllVehicles();
        setVehicles(data);
      } catch (err) {
        setError("Không thể tải danh sách xe. Vui lòng thử lại.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchVehicles();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Đang tải dữ liệu...</p>
      </div>
    );
  }

  return (
    <div className="home-page">
      {/* Vehicles Section (Moved to top) */}
      <section className="vehicles-section">
        <div className="container">
          {error && <div className="error-message">{error}</div>}

          {vehicles.length === 0 ?
            <p className="no-vehicles">Không có xe nào để hiển thị</p>
          : <div className="vehicles-grid">
              {vehicles.map((vehicle) => (
                <VehicleCard key={vehicle.vehicle_id} vehicle={vehicle} />
              ))}
            </div>
          }
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2>Tại Sao Chọn VinFast?</h2>
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">⚡</div>
              <h3>Công Nghệ Tiên Tiến</h3>
              <p>Hệ thống điện hóa hiện đại, pin LFP an toàn và bền bỉ</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🌍</div>
              <h3>Bền Vững</h3>
              <p>Giảm khí thải, thân thiện với môi trường</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🏆</div>
              <h3>Chất Lượng Cao</h3>
              <p>Thiết kế sang trọng, nội thất cao cấp</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">💰</div>
              <h3>Giá Cạnh Tranh</h3>
              <p>Chương trình khuyến mãi hấp dẫn, tài chính linh hoạt</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Bạn Sẵn Sàng Sở Hữu Một Chiếc VinFast?</h2>
          <p>
            Hãy liên hệ với chúng tôi ngay hôm nay để được tư vấn chi tiết và
            nhận ưu đãi tốt nhất.
          </p>
          <a href="/booking" className="btn btn-primary btn-lg">
            Liên Hệ Với Sale
          </a>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
